import { Product } from 'lib/enums/Product';

export const REPORTS_V2_COLORS = {
  column_blue: '#2D9BDB',
  column_yellow: '#FFC400',
  column_green: '#00925E',
  muted_blue: '#2f80ed',
  teal: '#42B097',
  muted_orange: '#F8CA6A',
  light_blue_gray: '#C9D8E6',
  navy: '#24415b',
  column_red: '#F04438',
  orange_500: '#EF6820',
  purple_500: '#7A5AF8',
  pink_500: '#D444F1',
  rose_500: '#EE46BC'
};

export const ORDER_TYPE_COLORS: Record<string, string> = {
  [Product.Obituary]: REPORTS_V2_COLORS.teal,
  [Product.Classified]: REPORTS_V2_COLORS.muted_orange,
  [Product.Notice]: REPORTS_V2_COLORS.navy
};
